import type { DashboardBuilderState } from '@signals/dashboard-ui';

export const USER_CONTENT_STORAGE_KEY = 'pathfinder_user_content_v1';
export const USER_CONTENT_VERSION = 1 as const;

/** @deprecated Workspace kind is no longer used; all dashboards are generic. Kept for migration. */
export type DashboardWorkspaceKind = 'cop' | 'spatial';

export interface SavedDashboard {
  id: string;
  name: string;
  updatedAt: string;
  /** @deprecated All dashboards are now generic. Legacy values are preserved for migration but ignored. */
  workspaceKind?: DashboardWorkspaceKind;
  state: DashboardBuilderState;
}

/** Placeholder until upload / linked-table flow exists. */
export interface UserDatasetStub {
  id: string;
  name: string;
  createdAt: string;
  kind: 'placeholder';
  note?: string;
}

export interface UserContentLibrary {
  version: typeof USER_CONTENT_VERSION;
  dashboards: SavedDashboard[];
  datasets: UserDatasetStub[];
}
